// extracted by mini-css-extract-plugin
export default {"sqbb_title":"SqbbPageTitle_sqbb_title__4cfWc","sqbb_title_h":"SqbbPageTitle_sqbb_title_h__IHuMB","sqbb_title_underline":"SqbbPageTitle_sqbb_title_underline__7+tRi"};